import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import ImageHistoryLogsService from "../../app/data/documents/imageHistoryLogsService";
import { initialImageHistoryLogsState } from "./ImageHistoryLogsState";
import { ImageHistoryLogsFilterModel } from "../../app/data/documents/imageHistoryLogsModels";

const imageHistoryLogsService = ImageHistoryLogsService.getInstance();

export const imageHistoryLogsSlice = createSlice({
    name: "imageHistoryLogs",
    initialState: initialImageHistoryLogsState,
    reducers: {
        requestStarted: (state, { payload }) => {
            state.requestStarted = true;
            state.requestSucceed = false;
            state.requestFailed = false;
            state.requestError = "";
            state.requestCreator = payload;
        },
        requestSucceed: (state) => {
            state.requestStarted = false;
            state.requestSucceed = true;
        },
        requestFailed: (state, { payload }) => {
            state.requestStarted = false;
            state.requestSucceed = false;
            state.requestFailed = true;
            state.requestError = payload;
        },
        resetErrors: (state) => {
            state.requestFailed = false;
            state.requestError = "";
        },
        setRecordsRequest: (state, { payload }) => {
            state.recordsRequest = {
                page: payload.page,
                last: payload.last
            }
        },
        setItemRecords: (state, { payload }) => {
            state.recordItems = payload;
        },
        addItemRecords: (state, { payload }) => {
            state.recordItems = [...state.recordItems, ...payload];
        },
        setImgHistoryCsvDownload: (state, { payload }) => {
            state.downloadCsv = payload;
        },
        setTableInfo: (state, { payload }) => {
            state.tableInfo = payload;
        }
    }
});

export const {
    requestStarted,
    requestSucceed,
    requestFailed,
    resetErrors,
    setRecordsRequest,
    setItemRecords,
    addItemRecords,
    setImgHistoryCsvDownload,
    setTableInfo
} = imageHistoryLogsSlice.actions;

export const imageHistoryLogsSelector = (state: IState) => state.imageHistoryLogs;

export const getImageHistoryLogs = (
    filter: ImageHistoryLogsFilterModel,
    page: number
): AppThunk => async (dispatch) => {
    dispatch(requestStarted(page ? "GET_RECORDS_PORTION" : "GET_RECORDS"));
    const response = await imageHistoryLogsService.getImageHistoryLogsRecords(filter, page);
    if (response.isCancel?.()) return;
    if (response.ok()) {
        dispatch(setRecordsRequest({
            page: response.data?.page,
            last: response.data?.totalPages
        }));
        dispatch(page ? addItemRecords(response.data.data) : setItemRecords(response.data.data));
        dispatch(requestSucceed());
    } else {
        dispatch(requestFailed(response.getError ? response.getError() : "Error"));
    }
};
export const updateImageHistoryCsvDownload = (downloadCsv: boolean): AppThunk => (dispatch) => {
    dispatch(setImgHistoryCsvDownload(downloadCsv));
};

export const getImageHistoryTableInfo = (): AppThunk => async (dispatch) => {
    const response = await imageHistoryLogsService.getImageHistoryTableInfo();
    if (response.isCancel?.()) return;
    if (response.ok()) {
        dispatch(setTableInfo(response.data));
    } else {
        dispatch(requestFailed(response.getError ? response.getError() : "Error"));
    }
};
const imageHistoryLogsReducer = imageHistoryLogsSlice.reducer;
export default imageHistoryLogsReducer;
